import React from 'react';

import {
  Breakpoints,
  Container,
} from '@vw-marketing/us-components';

import { MyVwContextProvider } from '../shared/context/MyVwContext';
import { ProvidersWrapper } from './components/ProvidersWrapper';
import { Routes } from './routes';
import { StyledAppContainer } from './styles';

interface AppProps {
  service: any;
  baseUrl?: string;
}

export const App: React.FC<AppProps> = ({ service, baseUrl }) => {
  return (
    <MyVwContextProvider service={service} baseUrl={baseUrl}>
      <ProvidersWrapper>
        <StyledAppContainer>
          <Container
            padding={{
              top: {
                [Breakpoints.default]: "static520",
                [Breakpoints.b1280]: "static600",
              },
              bottom: {
                [Breakpoints.default]: "static520",
                [Breakpoints.b1280]: "static600",
              },
            }}
            stretchContent
          >
            <Routes />
          </Container>
        </StyledAppContainer>
      </ProvidersWrapper>
    </MyVwContextProvider>
  );
};
